module.exports = __webpack_public_path__ + "static/img/candidate-care.017ce5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/candidate-care.png
// module id = IXyz
// module chunks = 0